import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function TagsAPI(): BringozApi {
  return {
    base: `/tags`,
    infiniteScroll: {
      address: `/tags`,
      cmd: 'GET'
    },
    actions: {
      createTag: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      editTag: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      deleteTag: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      getAllByTypes: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      getTagsByName: {
        address: 'byNames',
        cmd: 'GET'
      }
    }
  }
}

angular
  .module('bringoz.admin.tags')
  .factory('TagsAPI', TagsAPI);
